import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ProjectStatusBox.scss';
import ActionDropdown from '../common/ActionDropdown/ActionDropdown';
import MarkOnHold from '../MarkOnHold';
import EditInvoiceRate from '../EditInvoiceRate';
import ExecuteAgreementForProject from '../ExecuteAgreementForProject/ExecuteAgreementForProject';
import FullTimeRatesModal from '../FullTimeRatesModal/FullTimeRatesModal';
import WorkCompletedForProject from '../WorkCompletedForProject/WorkCompletedForProject';
import ProjectClosure from '../ProjectClosure/ProjectClosure';
var repProjectStatusMap = new Map([['employer_requested_matching', 'Employer Requested Matching'], ['clora_matching', 'Project In Matching'], ['clora_matched', 'Project Matched'], ['executed_agreement', 'Project Executed Agreement'], ['work_started', 'Project Work Started'], ['work_completed', 'Project Work Completed'], ['closed', 'Project Closed'], ['on_hold', 'Project On Hold'], ['employer_draft', 'Employer Draft']]);
var renderEmployerProjectStatus = function renderEmployerProjectStatus(status, isOpenMarketplaceOrRehire) {
  if (status === 'employer_draft') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Draft");
  }
  if (status === 'employer_requested_matching') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("h2", {
        className: "demibold"
      }, "Live!");
    }
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Under Review\xA0", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "right",
      delay: 100,
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "project-status-tooltip"
      }, "Clora will help you to shape your project's needs in a scoping call!")
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info-circle"
    })));
  }
  if (status === 'clora_matching') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Sourcing\xA0", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "right",
      delay: 100,
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "project-status-tooltip"
      }, "Your project is now public in our marketplace and our life-science experts are vetting candidates for you.")
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info-circle"
    })));
  }
  if (status === 'closed') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Closed");
  }
  if (status === 'clora_matched' || status === 'executed_agreement') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Matched");
  }
  if (status === 'work_started') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Work Started");
  }
  if (status === 'work_completed') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Work Completed");
  }
  if (status === 'on_hold') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "On Hold");
  }
  return null;
};
var handleDeleteProject = function handleDeleteProject(redirectUrl) {
  window.location.href = redirectUrl.url;
};
var calculateTakeRate = function calculateTakeRate(proposal, fallbackTakeRate) {
  if (!proposal || !proposal.gross_rate) return fallbackTakeRate * 100;
  var rawRate = 1.0 - proposal.net_rate / proposal.gross_rate;
  return Math.round(rawRate * 10000) / 100;
};
var ProjectStatusBox = /*#__PURE__*/function (_Component) {
  function ProjectStatusBox(props) {
    var _this;
    _classCallCheck(this, ProjectStatusBox);
    _this = _callSuper(this, ProjectStatusBox, [props]);
    _this.state = {
      isPublic: props.projectIsPublic,
      isFulfillmentPaused: props.projectHasFulfillmentPaused,
      status: props.projectStatus
    };
    _this.getLinks = _this.getLinks.bind(_this);
    _this.handlePublicToggle = _this.handlePublicToggle.bind(_this);
    _this.handleFulfillmentToggle = _this.handleFulfillmentToggle.bind(_this);
    _this.handleProjectStatusUpdate = _this.handleProjectStatusUpdate.bind(_this);
    return _this;
  }
  _inherits(ProjectStatusBox, _Component);
  return _createClass(ProjectStatusBox, [{
    key: "getLinks",
    value: function getLinks() {
      var _this$props = this.props,
        canBeginMatching = _this$props.canBeginMatching,
        beginMatchingLink = _this$props.beginMatchingLink,
        csrfToken = _this$props.csrfToken,
        resourceId = _this$props.resourceId,
        currentUserIsAdmin = _this$props.currentUserIsAdmin,
        executeAgreementUrl = _this$props.executeAgreementUrl,
        projectTakeRate = _this$props.projectTakeRate,
        markWorkStartedLink = _this$props.markWorkStartedLink,
        completeWorkUrl = _this$props.completeWorkUrl,
        projectCanBeOnHold = _this$props.projectCanBeOnHold,
        markOnHoldLink = _this$props.markOnHoldLink,
        resumeProjectFulfillment = _this$props.resumeProjectFulfillment,
        pauseProjectFulfillment = _this$props.pauseProjectFulfillment,
        projectIsClosed = _this$props.projectIsClosed,
        closeProjectUrl = _this$props.closeProjectUrl,
        primaryCloseReason = _this$props.primaryCloseReason,
        secondaryCloseReason = _this$props.secondaryCloseReason,
        projectIsMatching = _this$props.projectIsMatching,
        makeProjectPrivate = _this$props.makeProjectPrivate,
        makeProjectPublic = _this$props.makeProjectPublic,
        projectChangeHistory = _this$props.projectChangeHistory,
        projectStatusChange = _this$props.projectStatusChange,
        projectCanBeDeleted = _this$props.projectCanBeDeleted,
        projectPath = _this$props.projectPath,
        cloraTakeRate = _this$props.cloraTakeRate,
        acceptedProposal = _this$props.acceptedProposal,
        employmentType = _this$props.employmentType,
        quickbooksPaymentTerm = _this$props.quickbooksPaymentTerm,
        quickbooksPaymentTermOptions = _this$props.quickbooksPaymentTermOptions;
      var _this$state = this.state,
        isPublic = _this$state.isPublic,
        isFulfillmentPaused = _this$state.isFulfillmentPaused,
        status = _this$state.status;
      var links = [];
      if (canBeginMatching && status !== 'clora_matching') {
        links.push(['put', /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Clora Matching")), beginMatchingLink, this.handleProjectStatusUpdate]);
      }
      if (status === 'clora_matched') {
        if (employmentType === 'full_time') {
          links.push(['component', /*#__PURE__*/React.createElement(FullTimeRatesModal, {
            mode: "execute",
            triggerStyle: "dropdown-item",
            triggerText: /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Executed Agreement")),
            csrfToken: csrfToken,
            putUrl: executeAgreementUrl,
            projectTakeRate: projectTakeRate,
            quickbooksPaymentTerm: quickbooksPaymentTerm,
            quickbooksPaymentTermOptions: quickbooksPaymentTermOptions
          })]);
        } else {
          links.push(['component', /*#__PURE__*/React.createElement(ExecuteAgreementForProject, {
            triggerStyle: "dropdown-item",
            triggerText: /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Executed Agreement")),
            csrfToken: csrfToken,
            executeAgreementUrl: executeAgreementUrl,
            projectTakeRate: projectTakeRate,
            quickbooksPaymentTerm: quickbooksPaymentTerm,
            quickbooksPaymentTermOptions: quickbooksPaymentTermOptions
          })]);
        }
      }
      if (status === 'executed_agreement') {
        links.push(['put', /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Work Started")), markWorkStartedLink, this.handleProjectStatusUpdate]);
      }
      if (status === 'work_started') {
        links.push(['component', /*#__PURE__*/React.createElement(WorkCompletedForProject, {
          triggerStyle: "dropdown-item",
          triggerText: /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Work Completed")),
          csrfToken: csrfToken,
          completeWorkUrl: completeWorkUrl
        })]);
      }
      if (projectCanBeOnHold) {
        links.push(['component', /*#__PURE__*/React.createElement(MarkOnHold, {
          triggerStyle: "dropdown-item",
          triggerText: /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "On Hold")),
          triggerType: "link",
          formUrl: markOnHoldLink,
          csrfToken: csrfToken
        })]);
      }
      if (projectIsClosed) {
        links.push(['component', /*#__PURE__*/React.createElement(ProjectClosure, {
          csrfToken: csrfToken,
          triggerStyle: "dropdown-item",
          triggerText: "Update Closed Reason",
          closeProjectUrl: closeProjectUrl,
          resourceId: resourceId,
          primaryReason: primaryCloseReason,
          secondaryReason: secondaryCloseReason
        })]);
      } else {
        links.push(['component', /*#__PURE__*/React.createElement(ProjectClosure, {
          triggerStyle: "dropdown-item",
          triggerText: /*#__PURE__*/React.createElement("span", null, "Update Status to:\xA0", /*#__PURE__*/React.createElement("strong", null, "Closed")),
          csrfToken: csrfToken,
          closeProjectUrl: closeProjectUrl,
          resourceId: resourceId
        })]);
      }
      links.push(['separator', '----', function () {}, null, 'separator1']);
      if (projectIsMatching) {
        if (isPublic) {
          links.push(['put', 'Remove from Open Opp.', makeProjectPrivate, this.handlePublicToggle]);
        } else {
          links.push(['put', 'Show project on Open Opp.', makeProjectPublic, this.handlePublicToggle]);
        }
        if (isFulfillmentPaused) {
          links.push(['put', 'Resume fulfillment', resumeProjectFulfillment, this.handleFulfillmentToggle]);
        } else {
          links.push(['put', 'Pause fulfillment', pauseProjectFulfillment, this.handleFulfillmentToggle]);
        }
        links.push(['separator', '----', function () {}, null, 'separator2']);
      }
      if (['executed_agreement', 'work_started', 'work_completed'].includes(status) && acceptedProposal) {
        links.push(['component', employmentType === 'full_time' ? /*#__PURE__*/React.createElement(FullTimeRatesModal, {
          mode: "edit",
          triggerStyle: "dropdown-item",
          triggerText: "Edit Rates",
          submitButtonText: "Yes, Update Rates",
          csrfToken: csrfToken,
          putUrl: "/projects/".concat(resourceId),
          baseAnnualPay: acceptedProposal.base_annual_pay,
          conversionFee: acceptedProposal.conversion_fee,
          projectTakeRate: projectTakeRate,
          quickbooksPaymentTerm: quickbooksPaymentTerm,
          quickbooksPaymentTermOptions: quickbooksPaymentTermOptions
        }) : /*#__PURE__*/React.createElement(EditInvoiceRate, {
          net_rate: acceptedProposal.net_rate / 100.0,
          travel_rate: acceptedProposal.travel_rate / 100.0,
          gross_rate: acceptedProposal.gross_rate / 100.0,
          gross_travel_rate: acceptedProposal.gross_travel_rate / 100.0,
          hourLimit: acceptedProposal.hour_limit,
          takeRate: calculateTakeRate(acceptedProposal, cloraTakeRate),
          csrfToken: csrfToken,
          putUrl: "/projects/".concat(resourceId),
          isEditingProposal: false,
          className: "edit-invoice-rate me-3",
          quickbooksPaymentTerm: quickbooksPaymentTerm,
          quickbooksPaymentTermOptions: quickbooksPaymentTermOptions
        })]);
      }
      links.push(['link', 'See change history', projectChangeHistory]);
      if (currentUserIsAdmin) {
        links.push(['link', 'Force update status', projectStatusChange]);
      }
      if (projectCanBeDeleted) {
        links.push(['delete', 'Delete This Project', projectPath, handleDeleteProject]);
      }
      return links;
    }
  }, {
    key: "handlePublicToggle",
    value: function handlePublicToggle(publicStatus) {
      this.setState({
        isPublic: publicStatus
      });
    }
  }, {
    key: "handleFulfillmentToggle",
    value: function handleFulfillmentToggle(fulfillmentStatus) {
      this.setState({
        isFulfillmentPaused: fulfillmentStatus
      });
    }
  }, {
    key: "handleProjectStatusUpdate",
    value: function handleProjectStatusUpdate(project) {
      this.setState({
        status: project.status
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        currentUserIsRep = _this$props2.currentUserIsRep,
        isOpenMarketplaceOrRehire = _this$props2.isOpenMarketplaceOrRehire;
      var status = this.state.status;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-status-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-status-container-item"
      }, "Project Status:"), currentUserIsRep ? /*#__PURE__*/React.createElement(ActionDropdown, {
        id: "rep-actions",
        toggleStyle: "project-status-container-item",
        defaultLabel: repProjectStatusMap.get(status),
        csrfToken: csrfToken,
        links: this.getLinks(),
        buttonVariant: "default"
      }) : /*#__PURE__*/React.createElement("div", {
        className: "project-status-container-item"
      }, renderEmployerProjectStatus(status, isOpenMarketplaceOrRehire)));
    }
  }]);
}(Component);
ProjectStatusBox.propTypes = {
  currentUserIsRep: PropTypes.bool.isRequired,
  currentUserIsAdmin: PropTypes.bool.isRequired,
  projectStatus: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
  projectPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isOpenMarketplaceOrRehire: PropTypes.bool,
  canBeginMatching: PropTypes.bool.isRequired,
  beginMatchingLink: PropTypes.string.isRequired,
  projectIsMatching: PropTypes.bool.isRequired,
  executeAgreementUrl: PropTypes.string.isRequired,
  projectTakeRate: PropTypes.string.isRequired,
  markWorkStartedLink: PropTypes.string.isRequired,
  completeWorkUrl: PropTypes.string.isRequired,
  projectCanBeOnHold: PropTypes.bool.isRequired,
  markOnHoldLink: PropTypes.string.isRequired,
  projectIsClosed: PropTypes.bool.isRequired,
  closeProjectUrl: PropTypes.string.isRequired,
  primaryCloseReason: PropTypes.string,
  secondaryCloseReason: PropTypes.string,
  projectIsPublic: PropTypes.bool.isRequired,
  makeProjectPrivate: PropTypes.string.isRequired,
  makeProjectPublic: PropTypes.string.isRequired,
  projectHasFulfillmentPaused: PropTypes.bool.isRequired,
  resumeProjectFulfillment: PropTypes.string.isRequired,
  pauseProjectFulfillment: PropTypes.string.isRequired,
  projectChangeHistory: PropTypes.string.isRequired,
  projectStatusChange: PropTypes.string.isRequired,
  projectCanBeDeleted: PropTypes.bool.isRequired,
  cloraTakeRate: PropTypes.string.isRequired,
  acceptedProposal: PropTypes.shape({}),
  employmentType: PropTypes.string.isRequired,
  quickbooksPaymentTerm: PropTypes.string.isRequired,
  quickbooksPaymentTermOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }))
};
ProjectStatusBox.defaultProps = {
  isOpenMarketplaceOrRehire: false,
  primaryCloseReason: '',
  secondaryCloseReason: '',
  acceptedProposal: null,
  quickbooksPaymentTermOptions: []
};
export default ProjectStatusBox;